export { default as DefaultPage } from './DefaultPage';
export { default as AddListPage } from './AddListPage';
export { default as PositionTypePage } from './PositionTypePage';
export { default as CompanyTypePage } from './CompanyTypePage';
export { default as AreaPage } from './AreaPage';
export { default as BenefitsPage } from './BenefitsPage';
export { default as CertTypePage } from './CertTypePage';
export { default as EduPage } from './EduPage';
export { default as UserTagPage } from './UserTagPage';
export { default as SalaryRangePage } from './SalaryRangePage';
export { default as SalaryTypePage } from './SalaryTypePage';
export { default as WorkExperiencePage } from './WorkExperiencePage';
export { default as IndustryTypePage } from './IndustryTypePage';
export { default as PositionCategory } from './PositionCategory';



// WEBPACK FOOTER //
// ./src/features/system/index.js